import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
const IconDocumentPowerpoint = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-label="IconDocumentPowerpoint"
    fill="currentColor"
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M.844.844A2.88 2.88 0 0 1 2.88 0h18.24A2.88 2.88 0 0 1 24 2.88v18.24A2.88 2.88 0 0 1 21.12 24H2.88A2.88 2.88 0 0 1 0 21.12V2.88C0 2.116.303 1.384.844.844m8.599 15.902a1.3 1.3 0 0 1-.717-.148.65.65 0 0 1-.252-.396 2.3 2.3 0 0 1-.054-.504V8.285a2 2 0 0 1 .054-.488.63.63 0 0 1 .272-.395c.22-.115.468-.167.716-.148h2.796c.386.003.768.072 1.13.204a3.2 3.2 0 0 1 1.075.638c.34.286.615.643.804 1.045.218.458.326.96.314 1.467a3.2 3.2 0 0 1-1.118 2.499 3.7 3.7 0 0 1-1.075.625 3.5 3.5 0 0 1-1.158.204h-1.745v1.779q0 .255-.054.503a.63.63 0 0 1-.272.38c-.22.116-.468.167-.716.148"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M10.5 11.871h1.758c.202 0 .401-.043.586-.124.2-.09.37-.236.49-.42.144-.217.216-.473.205-.733a1.3 1.3 0 0 0-.163-.664 1.16 1.16 0 0 0-.464-.448 1.33 1.33 0 0 0-.668-.163h-1.745z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = /* #__PURE__ */ forwardRef(IconDocumentPowerpoint);
const Memo = /* #__PURE__ */ memo(ForwardRef);
export default Memo;
